import * as React from 'react';

import { Root } from './styled';


export type BoxShadowProps = {
	elevation?: number;
	style?: React.CSSProperties;
}

const BoxShadow: React.SFC<BoxShadowProps> = (props) => {
	return (
		<Root {...props} />
	);
}

BoxShadow.displayName = 'BoxShadow';
BoxShadow.defaultProps = {
	elevation: 1,
};

export default BoxShadow;
